import React, {Ref, forwardRef} from 'react'
import classNames from 'classnames'
import Select, {createFilter, SelectInstance, GroupBase} from 'react-select'
import type {Props as SelectProps} from 'react-select'
import customSelectStyles from 'Src/utilities/customSelectStyles'

export interface A2zSelectProps
  extends SelectProps<Record<string, string>, true, GroupBase<Record<string, string>>> {
  disabled?: boolean
  required?: boolean
  loading?: boolean | null
  name?: string
  label?: string
  error?: string
}

type ReactSelectRef = SelectInstance<
  Record<string, string>,
  true,
  GroupBase<Record<string, string>>
>

const searchConfig = {
  matchFrom: 'start' as const,
}

const customSelectStylesWithOverrides = {
  ...customSelectStyles,
  placeholder: () => ({
    display: 'none',
  }),
}

const InputSelect = forwardRef(
  (
    {
      disabled = false,
      loading = null,
      error = '',
      label = undefined,
      name = '',
      required = false,
      ...props
    }: A2zSelectProps,
    ref: Ref<ReactSelectRef>
  ) => {
    const hasOptions = 'options' in props && Array.isArray(props.options) && props.options?.length

    return (
      <>
        {label ? (
          <label
            htmlFor={name}
            className={classNames('tw-mt-2 tw-font-semibold', {
              'tw-text-brand-body_text--muted': disabled,
              required,
            })}
          >
            {label}
          </label>
        ) : null}
        <Select
          ref={ref}
          name={name}
          classNamePrefix="select"
          inputId={name}
          styles={customSelectStylesWithOverrides}
          filterOption={createFilter(searchConfig)}
          isDisabled={disabled}
          isLoading={loading !== null ? loading : !disabled && !hasOptions}
          isSearchable
          {...props}
        />
        {error ? (
          <span role="alert" className="tw-block tw-text-sm tw-text-brand-body_text--danger">
            {error}
          </span>
        ) : null}
      </>
    )
  }
)

export default InputSelect
